<div
  class="cads-spinner"
  role="status"
  [attr.aria-label]="_accessibleLabel()"
  [attr.aria-live]="_accessibleLabel() ? 'polite' : null"
>
  <div
    class="cads-spinner__lds"
    [class.cads-spinner__lds--small]="_size() === 'small'"
    [class.cads-spinner__lds--medium]="_size() === 'medium'"
    [class.cads-spinner__lds--large]="_size() === 'large'"
    [style.--cads-spinner-color]="_color()"
    aria-hidden="true"
  >
    @for (arm of _arms; track arm) {
      <div><div></div></div>
    }
  </div>

  @if (_label(); as caption) {
    <p class="cads-spinner__label">{{ caption }}</p>
  }
</div>
